import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { ViewEncapsulation, Component, Input, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatCardHeader, MatCardTitle, MatCardSubtitle, MatCard, MatCardActions, MatCardContent, MatCardFooter, MatCardModule } from '@angular/material/card';

const materialComponents$1 = [MatCardHeader, MatCardTitle, MatCardSubtitle];
/**
 * To use this component in a module, you can import the `CentricCardModule`:
 * @example
 * ```typescript
 * import { CentricCardModule } from '@windmill/ng-windmill/deprecated-card';
 * ```
 *
 * To use the standalone component directly, you can import `CardHeaderComponent`:
 * @example
 * ```typescript
 * import { CardHeaderComponent } from '@windmill/ng-windmill/deprecated-card';
 * ```
 */
class CardHeaderComponent {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: CardHeaderComponent, isStandalone: true, selector: "centric-card-header", ngImport: i0, template: "<mat-card-header>\r\n  <mat-card-title>\r\n    <ng-content select=\"[centric-card-title]\"></ng-content>\r\n  </mat-card-title>\r\n  <mat-card-subtitle>\r\n    <ng-content select=\"[centric-card-subtitle]\"></ng-content>\r\n  </mat-card-subtitle>\r\n  <ng-content></ng-content>\r\n</mat-card-header>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: MatCardHeader, selector: "mat-card-header" }, { kind: "directive", type: MatCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }, { kind: "directive", type: MatCardSubtitle, selector: "mat-card-subtitle, [mat-card-subtitle], [matCardSubtitle]" }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CardHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'centric-card-header', encapsulation: ViewEncapsulation.None, imports: [CommonModule, ...materialComponents$1], standalone: true, template: "<mat-card-header>\r\n  <mat-card-title>\r\n    <ng-content select=\"[centric-card-title]\"></ng-content>\r\n  </mat-card-title>\r\n  <mat-card-subtitle>\r\n    <ng-content select=\"[centric-card-subtitle]\"></ng-content>\r\n  </mat-card-subtitle>\r\n  <ng-content></ng-content>\r\n</mat-card-header>\r\n" }]
        }] });

const materialComponents = [MatCard, MatCardActions, MatCardContent, MatCardFooter, MatCardModule];
/**
 * To use this component in a module, you can import the `CentricCardModule`:
 * @example
 * ```typescript
 * import { CentricCardModule } from '@windmill/ng-windmill/deprecated-card';
 * ```
 *
 * To use the standalone component directly, you can import `CardComponent`:
 * @example
 * ```typescript
 * import { CardComponent } from '@windmill/ng-windmill/deprecated-card';
 * ```
 */
class CardComponent {
    /**
     * If true, then the footer is displayed
     */
    showFooter = false;
    /**
     * If true, then the actions side is displayed
     */
    showActions = false;
    /**
     * If true, then the card has shadow
     */
    shadow = false;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "19.2.10", type: CardComponent, isStandalone: true, selector: "centric-card", inputs: { showFooter: "showFooter", showActions: "showActions", shadow: "shadow" }, ngImport: i0, template: "<mat-card\r\n  class=\"centric-card\"\r\n  [appearance]=\"'outlined'\"\r\n  [class.has-shadow]=\"shadow\">\r\n  <ng-content></ng-content>\r\n  <mat-card-content>\r\n    <ng-content select=\"[centric-card-content]\"></ng-content>\r\n  </mat-card-content>\r\n  @if (showActions) {\r\n    <mat-card-actions>\r\n      <ng-content select=\"[centric-card-actions]\"></ng-content>\r\n    </mat-card-actions>\r\n  }\r\n  @if (showFooter) {\r\n    <mat-card-footer>\r\n      <ng-content select=\"[centric-card-footer]\"></ng-content>\r\n    </mat-card-footer>\r\n  }\r\n</mat-card>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "component", type: MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "directive", type: MatCardActions, selector: "mat-card-actions", inputs: ["align"], exportAs: ["matCardActions"] }, { kind: "directive", type: MatCardContent, selector: "mat-card-content" }, { kind: "directive", type: MatCardFooter, selector: "mat-card-footer" }, { kind: "ngmodule", type: MatCardModule }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'centric-card', encapsulation: ViewEncapsulation.None, imports: [CommonModule, ...materialComponents], standalone: true, template: "<mat-card\r\n  class=\"centric-card\"\r\n  [appearance]=\"'outlined'\"\r\n  [class.has-shadow]=\"shadow\">\r\n  <ng-content></ng-content>\r\n  <mat-card-content>\r\n    <ng-content select=\"[centric-card-content]\"></ng-content>\r\n  </mat-card-content>\r\n  @if (showActions) {\r\n    <mat-card-actions>\r\n      <ng-content select=\"[centric-card-actions]\"></ng-content>\r\n    </mat-card-actions>\r\n  }\r\n  @if (showFooter) {\r\n    <mat-card-footer>\r\n      <ng-content select=\"[centric-card-footer]\"></ng-content>\r\n    </mat-card-footer>\r\n  }\r\n</mat-card>\r\n" }]
        }], propDecorators: { showFooter: [{
                type: Input
            }], showActions: [{
                type: Input
            }], shadow: [{
                type: Input
            }] } });

const moduleComponents = [CardComponent, CardHeaderComponent];
class CentricCardModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: CentricCardModule, imports: [CommonModule, MatCardModule, CardComponent, CardHeaderComponent], exports: [CardComponent, CardHeaderComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricCardModule, imports: [CommonModule, MatCardModule, moduleComponents] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, MatCardModule, ...moduleComponents],
                    exports: [...moduleComponents],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CardComponent, CardHeaderComponent, CentricCardModule };
